import Immutable from 'immutable';
import {
  CLEAR_ERROR_POSTING_OCCUPANCY_REPORT,
  DOWNLOAD_OCCUPANCY_REPORT,
  FLAG_POSTING_OCCUPANCY_REPORT,
  POST_OCCUPANCY_REPORT,
  SHOW_ERROR_POSTING_OCCUPANCY_REPORT,
  GET_OCCUPANCY_REPORTS,
  GET_OCCUPANCY_REPORT,
  CLEAR_OCCUPANCY_REPORTS,
  CLEAR_OCCUPANCY_REPORT,
  FLAG_GETTING_OCCUPANCY_REPORTS,
  FLAG_GETTING_OCCUPANCY_REPORT,
  CLEAR_ERROR_GETTING_OCCUPANCY_REPORTS,
  CLEAR_ERROR_GETTING_OCCUPANCY_REPORT,
  SHOW_ERROR_GETTING_OCCUPANCY_REPORT,
  SHOW_ERROR_GETTING_OCCUPANCY_REPORTS,
} from '../../../actions/types';
import downloadCsv from '../../../utils/download-csv';

const INITIAL_STATE = Immutable.Map({
  form: Immutable.Map({
    error: null,
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    error: null,
    loading: false,
  }),
  all: Immutable.Map({
    content: Immutable.Map(),
    error: null,
    loading: false,
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // downloading
    case DOWNLOAD_OCCUPANCY_REPORT:
      downloadCsv(action.payload, 'occupancy-report.csv');
      return state;

    // posting
    case FLAG_POSTING_OCCUPANCY_REPORT:
      return state.setIn(['form', 'loading'], action.payload);
    case POST_OCCUPANCY_REPORT:
      return state.setIn(['current', 'content'], Immutable.Map(action.payload));
    case SHOW_ERROR_POSTING_OCCUPANCY_REPORT:
      return state.setIn(['form', 'error'], action.payload);
    case CLEAR_ERROR_POSTING_OCCUPANCY_REPORT:
      return state.deleteIn(['form', 'error']);

    // getting all
    case GET_OCCUPANCY_REPORTS:
      return state.setIn(['all', 'content'], Immutable.Map(action.payload));
    case FLAG_GETTING_OCCUPANCY_REPORTS:
      return state.setIn(['all', 'loading'], action.payload);
    case CLEAR_OCCUPANCY_REPORTS:
      return state.deleteIn(['all', 'content']);
    case SHOW_ERROR_GETTING_OCCUPANCY_REPORTS:
      return state.setIn(['all', 'error'], action.payload);
    case CLEAR_ERROR_GETTING_OCCUPANCY_REPORTS:
      return state.deleteIn(['all', 'error']);

    // getting one
    case GET_OCCUPANCY_REPORT:
      return state.setIn(['current', 'content'], Immutable.Map(action.payload));
    case FLAG_GETTING_OCCUPANCY_REPORT:
      return state.setIn(['current', 'loading'], action.payload);
    case CLEAR_OCCUPANCY_REPORT:
      return state.deleteIn(['current', 'content']);
    case SHOW_ERROR_GETTING_OCCUPANCY_REPORT:
      return state.setIn(['current', 'error'], action.payload);
    case CLEAR_ERROR_GETTING_OCCUPANCY_REPORT:
      return state.deleteIn(['current', 'error']);

    default:
      return state;
  }
};
